import { createStore } from "redux";
// import { persistStore, persistReducer, } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
// import reduxPersistConfig from "./reduxPresistConfig";
import {
  CLAIMAMOUNT,
  CLAIMLISTDATA,
  CLAIMSTATUS,
  CROPDATA,
  GENUNITYSTATUSDATA,
  GIFTURL,
  ISSPINNED,
  LOGIN,
  LOGOUT,
  MYREWARDS,
  RECLAIMDATA,
  REGISTRATION,
  SCANDATAURL,
  SPINDATA,
  SET_SECONDARY_MESSAGE
} from "./authActionTypes";
import { decryptJSON, encryptJSON } from "../../service/Encrtyption";
import persistReducer from "redux-persist/es/persistReducer";
import persistStore from "redux-persist/es/persistStore";

export const setSecondaryMessageAction = (message) => ({
  type: SET_SECONDARY_MESSAGE,
  payload: { message },
});

export const login = (user) => ({
  type: LOGIN,
  payload: { user },
});
export const scanData = (scandataUrl) => ({
  type: SCANDATAURL,
  payload: { scandataUrl },
});
export const genuityCheckData = (genunityData) => ({
  type: GENUNITYSTATUSDATA,
  payload: { genunityData },
});
export const myRewards = (myRewardsData) => ({
  type: MYREWARDS,
  payload: { myRewardsData },
});
export const registerData = (registration) => ({
  type: REGISTRATION,
  payload: { registration },
});
export const spinStatus = (spinValue) => ({
  type: ISSPINNED,
  payload: { spinValue },
});
export const claimStatus = (claimValue) => ({
  type: CLAIMSTATUS,
  payload: { claimValue },
});
export const reclaimDataSave = (reclaimDataObj) => ({
  type: RECLAIMDATA,
  payload: { reclaimDataObj },
});
export const rewardMoney = (amount) => ({
  type: CLAIMAMOUNT,
  payload: { amount },
});
export const cropValue = (cropData) => ({
  type: CROPDATA,
  payload: { cropData },
});
export const giftImageUrlFun = (giftImageUrl) => ({
  type: GIFTURL,
  payload: { giftImageUrl },
});
export const logout = () => ({
  type: LOGOUT
});

const storedUserData = sessionStorage.getItem("userData");
const initialState = {
  user: storedUserData ? decryptJSON(storedUserData) : null,
  isAuthenticated: false,
  // isSpin: false,
  claimValue: false,
  genunityData: {},
  isSpinData: {
    "isSpin": false,
    "retailerMobileNumber": "",
    "selectedCropName": "",
    "selectedCropId": ""
  },
  myRewardsData: {},
  reclaimDataObj: {},

  amount: 0,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {

    case SET_SECONDARY_MESSAGE:
      return {
        ...state,
        message: action?.payload?.message,
      };


    case LOGIN:
      sessionStorage.setItem("userData", encryptJSON(action.payload.user));
      return {
        ...state,
        user: action?.payload?.user,
        isAuthenticated: true,
      };
    case REGISTRATION:
      return {
        ...state,
        registration: action?.payload?.registration,
        isAuthenticated: true,
      };
    case MYREWARDS:
      return {
        ...state,
        myRewardsData: action?.payload?.myRewardsData,
        isAuthenticated: true,
      };
    case RECLAIMDATA:
      return {
        ...state,
        reclaimDataObj: action?.payload?.reclaimDataObj,
        isAuthenticated: true,
      };
    case CLAIMSTATUS:
      return {
        ...state,
        claimValue: action?.payload?.claimValue,
        isAuthenticated: true,
      };
    case CLAIMAMOUNT:
      return {
        ...state,
        amount: action?.payload?.amount,
        isAuthenticated: true,
      };
    case SCANDATAURL:
      return {
        ...state,
        scandataUrl: action?.payload?.scandataUrl,
        isAuthenticated: true,
      };
    case GENUNITYSTATUSDATA:
      return {
        ...state,
        genunityData: action?.payload?.genunityData,
        isAuthenticated: true,
      };
    case ISSPINNED:
      return {
        ...state,
        spinValue: action?.payload?.spinValue,
        isAuthenticated: true,
      };
    case CROPDATA:
      return {
        ...state,
        cropData: action?.payload?.cropData,
        isAuthenticated: true,
      };
    case GIFTURL:
      return {
        ...state,
        giftImageUrl: action?.payload?.giftImageUrl,
        isAuthenticated: true,
      };
    case LOGOUT:
      return {
        ...state,
        user: null,
        isAuthenticated: false,
      };

    default:
      return state;
  }
};

const reduxPersistConfig = {
  key: "root",
  storage,
  whitelist: ["genunityData", "cropData", "scandataUrl", "myRewardsData", "reclaimDataObj", "amount","spinValue", "claimValue", "giftImageUrl","user","message"],
};

const persistedReducer = persistReducer(reduxPersistConfig, authReducer);
const store = createStore(persistedReducer);
const persistor = persistStore(store);

export { persistor, store };

// const persistedReducer = persistReducer(reduxPersistConfig, authReducer);

// const store = createStore(authReducer);
// const persistor = persistStore(store);

// export { store };
